import React from 'react';
import { Menu, MenuButton, MenuList, MenuItem, IconButton, Box, Flex } from '@chakra-ui/react';
import { faEllipsisH, faCloudArrowUp } from '@fortawesome/pro-regular-svg-icons';
import { Icon } from 'shared-components';
import { IApplicantOfferRequirementTask } from 'types';
import { useInternalDocumentUpload } from '@/hooks/useInternalDocumentUpload';
import { InternalDocumentUploadModal } from './InternalDocumentUploadModal';
import { useTranslation } from "react-i18next";

interface InternalDocumentUploadBtnProps {
  requirement: IApplicantOfferRequirementTask;
  offerId: string;
}

const InternalDocumentUploadBtn: React.FC<InternalDocumentUploadBtnProps> = ({ requirement, offerId }) => {
    const { t } = useTranslation('common');
  const { isOpen, onOpen, onClose, ...modalProps } = useInternalDocumentUpload({ requirement, offerId });

  return (
    <>
      <InternalDocumentUploadModal requirement={requirement} isOpen={isOpen} onClose={onClose} {...modalProps} />
      <Box my={-1}>
        <Menu placement="bottom-end">
          <MenuButton
            as={IconButton}
            icon={<Icon icon={faEllipsisH} />}
            size="sm"
            variant="secondary"
            colorScheme="gray"
            aria-label={t('common:uploadInternalDocument')}
          />
          <MenuList>
            <MenuItem onClick={onOpen}>
              <Flex align="center">
                <Icon icon={faCloudArrowUp} mr={2} />
                {t('common:uploadFile')}
                                            </Flex>
            </MenuItem>
          </MenuList>
        </Menu>
      </Box>
    </>
  );
};

export default InternalDocumentUploadBtn;
